// extracted by mini-css-extract-plugin
export var contrastLow = "_36-1";
export var externalLink = "_36-2";
export var externalLinkIcon = "_36-3";
export var link = "_36-0";
export var linkLabel = "_36-4";